import React, { useEffect } from 'react';
import toastError from "../../errors/toastError";

import { makeStyles } from "@material-ui/core/styles";

// Localização dentro da bolha, no padrão do WhatsApp Web: miniatura do mapa, descrição com a
// cor do texto da bolha e a ação separada por um filete fino.
const useStyles = makeStyles((theme) => {
	const isDark = theme.palette.type === "dark";
	const link = isDark ? "#53bdeb" : "#027eb5";
	return {
		card: {
			minWidth: 240,
			maxWidth: 320,
			margin: "0 0 4px -3px",
			color: "inherit",
			whiteSpace: "normal",
		},
		head: {
			display: "flex",
			alignItems: "center",
			gap: 12,
			padding: "3px 6px 9px 3px",
		},
		thumb: {
			flex: "none",
			width: 88,
			height: 88,
			objectFit: "cover",
			borderRadius: 6,
			cursor: "pointer",
			backgroundColor: isDark ? "rgba(255,255,255,0.06)" : "rgba(11,20,26,0.05)",
		},
		description: {
			flex: 1,
			minWidth: 0,
			fontSize: 13.5,
			lineHeight: "18px",
			wordBreak: "break-word",
			"& > div:first-child": {
				fontWeight: 500,
			},
		},
		action: {
			display: "block",
			width: "100%",
			margin: 0,
			padding: "9px 8px",
			border: 0,
			borderTop: `1px solid ${isDark ? "rgba(233,237,239,0.14)" : "rgba(11,20,26,0.1)"}`,
			background: "transparent",
			color: link,
			font: "inherit",
			fontSize: 14,
			fontWeight: 500,
			textAlign: "center",
			cursor: "pointer",
			borderRadius: "0 0 6px 6px",
			"&:hover": {
				backgroundColor: isDark ? "rgba(255,255,255,0.05)" : "rgba(11,20,26,0.04)",
			},
			"&:focus-visible": {
				outline: `2px solid ${link}`,
				outlineOffset: -2,
			},
			"&:disabled": {
				opacity: 0.5,
				cursor: "default",
				backgroundColor: "transparent",
			},
		},
	};
});

const LocationPreview = ({ image, link, description }) => {
	const classes = useStyles();
	useEffect(() => { }, [image, link, description]);

	const handleLocation = async () => {
		try {
			window.open(link);
		} catch (err) {
			toastError(err);
		}
	}

	// A descrição vem do contato: vai como texto (antes ia como HTML cru). A quebra chega
	// escrita como "\n" literal ou como quebra de linha de verdade.
	const lines = description
		? String(description).split(/\\n|\n/).filter((line) => line.trim() !== "")
		: [];

	return (
		<div className={classes.card}>
			<div className={classes.head}>
				<img
					src={image}
					alt="Mapa da localização"
					onClick={handleLocation}
					className={classes.thumb}
				/>
				{lines.length > 0 && (
					<div className={classes.description}>
						{lines.map((line, index) => (
							<div key={index}>{line}</div>
						))}
					</div>
				)}
			</div>
			<button
				type="button"
				className={classes.action}
				onClick={handleLocation}
				disabled={!link}
			>
				Abrir no mapa
			</button>
		</div>
	);

};

export default LocationPreview;
